import type { Dispatcher, EventInstance } from '@ngrx/signals/events';

/**
 * Dispatches a keyboard-triggered analytics event, automatically injecting
 * `triggered_from_keyboard: true` into the payload and exiting early when
 * no dispatcher is available.
 *
 * Usage:
 *   dispatchKeyboardAnalyticsEvent(dispatcher, someUiEvents.someTriggered);
 *   dispatchKeyboardAnalyticsEvent(dispatcher, styleElementUiEvents.fontBoldChanged, { status });
 */
export function dispatchKeyboardAnalyticsEvent<
  P extends { triggered_from_keyboard?: boolean },
>(
  dispatcher: Dispatcher | undefined,
  eventCreator: (payload: P) => EventInstance<string, unknown>,
  payload: Omit<P, 'triggered_from_keyboard'>,
): void {
  if (!dispatcher) return;
  const keyboardPayload = {
    ...payload,
    triggered_from_keyboard: true as const,
  } as P;
  dispatcher.dispatch(eventCreator(keyboardPayload));
}
